import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'

export function getSignPage(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/industrialinjurySign/gl/v1.0.0/page`,
        method: 'post',
        data
    })
}

export function addSign(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/industrialinjurySign/gl/v1.0.0/add`,
        method: 'post',
        data
    })
}

export function updateSign(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/industrialinjurySign/gl/v1.0.0/update`,
        method: 'post',
        data
    })
}

export function deleteSign(id) {
    return request({
        url: `/${systemConfig.businessPrefix}/industrialinjurySign/gl/v1.0.0/delete`,
        method: 'post',
        data: { id }
    })
}

export function getSignTemplate() {
    return request({
        url: `/${systemConfig.businessPrefix}/industrialinjurySign/gl/v1.0.0/excelTemplateGain`,
        method: 'post',
        responseType: 'blob'
    })
}

export function importSign(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/industrialinjurySign/gl/v1.0.0/signImport`,
        method: 'post',
        data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}
